
import React from 'react';
import { Moon, Sun, ShieldCheck, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

interface HeaderProps {
  isDark: boolean;
  toggleTheme: () => void;
  onLogout: () => void;
}

export const Header: React.FC<HeaderProps> = ({ isDark, toggleTheme, onLogout }) => {
  const { user, profile } = useUser();
  const navigate = useNavigate();
  const isAdmin = profile?.role === "admin" || user?.email === "yousefkatato66@gmail.com";

  return (
    <header className="relative z-20 w-full p-3 md:p-6 flex justify-between items-center transition-all">
      {/* Left Section: Theme Toggle Only (Simplified for mobile) */}
      <div className={`flex items-center gap-2 p-1 md:p-1.5 border transition-all shadow-sm rounded-full backdrop-blur-md ${isDark ? 'bg-black/40 border-white/10' : 'bg-white/40 border-white/30'}`}>
        <button
          onClick={toggleTheme}
          className={`${isDark ? 'bg-indigo-600' : 'bg-yellow-400'} w-8 h-8 md:w-11 md:h-11 rounded-full shadow-inner transition-all transform hover:scale-110 active:scale-90 flex items-center justify-center`}
        >
          {isDark ? (
            <Sun size={18} className="text-white fill-white" />
          ) : (
            <Moon size={18} className="text-blue-900 fill-blue-900" />
          )}
        </button>
      </div>

      <div className="flex gap-2">
        {isAdmin && (
          <button
            onClick={() => navigate('/admin')}
            className={`flex items-center gap-1.5 md:gap-2 ${isDark ? 'bg-red-500/20 text-red-400 border-red-500/30' : 'bg-red-50 text-red-600 border-red-100'} backdrop-blur-md px-3 md:px-5 py-1.5 md:py-2 rounded-full border font-black text-[10px] md:text-sm transition-all active:scale-95`}
          >
            <ShieldCheck size={14} className="md:w-5 md:h-5" />
            <span>لوحة التحكم</span>
          </button>
        )}
        <button
          onClick={onLogout}
          className={`flex items-center gap-1.5 md:gap-2 ${isDark ? 'bg-white/5 text-white/60 border-white/10 hover:bg-white/10' : 'bg-white text-slate-600 border-slate-100 hover:bg-slate-50'} backdrop-blur-md px-3 md:px-5 py-1.5 md:py-2 rounded-full border font-black text-[10px] md:text-sm transition-all active:scale-95 shadow-sm`}
        >
          <LogOut size={14} className="md:w-5 md:h-5 rotate-180" />
          <span className="hidden sm:inline">خروج</span>
        </button>
      </div>
    </header>
  );
};
